<template>
  <div id="app">
    <b-sidebar
      v-if="isLoggedIn && isServerAvailable"
      id="sidebar-1"
      shadow
      no-header
      no-enforce-focus
      no-close-on-route-change
      v-model="isOpenMenu"
      width="260px"
    >
      <div class="sidebar-brand-container">
        <img src="../static/logo.svg" alt="Logo" class="logo-main"/>
        <v-icon name="navbar/toggle_menu_left" :size="13" class="mr-1" v-b-toggle.sidebar-1/>
      </div>

      <b-list-group id="menu" flush class="menu text-menu">
        <b-list-group-item v-if="hasPermTask" :to="{ name: 'Tasks'}" :class="$route.name === 'Tasks' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/tasks" :size="13" class="mr-1"/>
          Заявки на смену
        </b-list-group-item>
        <b-list-group-item v-if="hasPermOrganization" :to="{ path: '/organizations'}" :class="$route.path === '/organizations' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/organizations" :size="13" class="mr-1"/>
          Наши организации
        </b-list-group-item>
        <b-list-group-item v-if="hasPermCustomer" :to="{ path: '/customers'}" :class="$route.path === '/customers' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/customers" :size="13" class="mr-1"/>
          {{ $t("message.customers.title") }}
        </b-list-group-item>
        <b-list-group-item v-if="hasPermLocation" :to="{ path: '/locations'}" :class="$route.path === '/locations' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/locations" :size="13" class="mr-1"/>
          {{ $t("message.locations.title") }}
        </b-list-group-item>
        <b-list-group-item v-if="hasPermRecruitTask" :to="{ path: '/recruit_tasks'}" :class="$route.path === '/recruit_tasks' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/recruit_tasks" :size="13" class="mr-1"/>
          Заявки на подбор
        </b-list-group-item>
        <b-list-group-item v-if="hasPermRecruitJobPosting" :to="{ path: '/recruit_job_postings'}" :class="$route.path === '/recruit_job_postings' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/job_postings" :size="13" class="mr-1"/>
          Объявления
        </b-list-group-item>
        <b-list-group-item v-if="hasPermRecruitJobPosting" :to="{ path: '/responses'}" :class="$route.path === '/responses' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/job_posting_responses" :size="13" class="mr-1"/>
          Отклики
        </b-list-group-item>
        <b-list-group-item v-if="hasPermWorker" :to="{ path: '/workers'}" :class="$route.path === '/workers' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/users" :size="13" class="mr-1"/>
          {{ $t("message.workers.title") }}
        </b-list-group-item>
        <b-list-group-item v-if="hasPermStaff" :to="{ path: '/staffs'}" :class="$route.path === '/staffs' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/staffs" :size="13" class="mr-1"/>
          Штатный персонал
        </b-list-group-item>
        <b-list-group-item v-if="hasPermStaff" :to="{ path: '/invoices'}" :class="$route.path === '/invoices' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/invoices" :size="13" class="mr-1"/>
          Выставление счёта
        </b-list-group-item>
        <b-list-group-item v-if="hasPermStaff" :to="{ path: '/reconciliation_acts'}" :class="$route.path === '/reconciliation_acts' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/reconciliation_acts" :size="13" class="mr-1"/>
          Акты сверки
        </b-list-group-item>
        <b-list-group-item v-if="hasPermStatistic" v-b-toggle:collapse-statistics :variant="navVariant">
          <v-icon name="navbar/statistics" :size="13" class="mr-1"/>
          Статистика
          <span class="float-right when-open ml-auto">
              <v-icon name="buttons/chevrons_up" :size="11"/>
            </span>
          <span class="float-right when-closed ml-auto">
              <v-icon name="buttons/chevrons_right" :size="11"/>
            </span>
        </b-list-group-item>
        <b-collapse id="collapse-statistics">
          <b-list-group-item :to="{ name: 'ManagerStatistics'}" :class="$route.name === 'ManagerStatistics' && 'active router-link-active'" :variant="navVariant">
              <span class="text-small">
                По менеджерам
              </span>
          </b-list-group-item>
          <b-list-group-item :to="{ name: 'CustomerStatistics'}" :class="$route.name === 'CustomerStatistics' && 'active router-link-active'" :variant="navVariant">
              <span class="text-small">
                По заказчикам
              </span>
          </b-list-group-item>
        </b-collapse>
        <b-list-group-item v-if="hasPermAnalytic" :to="{ path: '/analytics'}" :class="$route.path === '/analytics' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/analitics" :size="13" class="mr-1"/>
          Аналитика
        </b-list-group-item>
        <b-list-group-item v-if="hasPermReport" :to="{ path: '/reports'}" :class="$route.path === '/reports' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/reports" :size="13" class="mr-1"/>
          Отчёты
        </b-list-group-item>
        <b-list-group-item v-if="hasPermRegister" :to="{ name: 'Register'}" :class="$route.name === 'Register' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/register" :size="13" class="mr-1"/>
          Общий реестр
        </b-list-group-item>
        <b-list-group-item v-if="hasPermUser" :to="{ path: '/users'}" :class="$route.path === '/users' && 'active router-link-active'" :variant="navVariant">
          <v-icon name="navbar/user_cog" :size="13" class="mr-1"/>
          Пользователи
        </b-list-group-item>
        <b-list-group-item v-if="hasPermCatalog" v-b-toggle:collapse-catalogs :variant="navVariant">
          <v-icon name="navbar/catalogs" :size="13" class="mr-1"/>
          Справочники
          <span class="float-right when-open ml-auto">
              <v-icon name="buttons/chevrons_up" :size="11"/>
            </span>
          <span class="float-right when-closed ml-auto">
              <v-icon name="buttons/chevrons_right" :size="11"/>
            </span>
        </b-list-group-item>
        <b-collapse id="collapse-catalogs">
          <b-list-group-item v-if="hasPermCatalogTown" :to="{ path: '/town_catalogs'}" :class="$route.path === '/town_catalogs' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Города
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogCitizenship" :to="{ path: '/citizenships'}" :class="$route.path === '/citizenships' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Гражданства
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogWorkType" :to="{ path: '/work_type_catalogs'}" :class="$route.path === '/work_type_catalogs' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Виды работ
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogSource" :to="{ path: '/marketing_sources'}" :class="$route.path === '/marketing_sources' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Маркетинговые источники
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogWorkerSource" :to="{ path: '/worker_sources'}" :class="$route.path === '/worker_sources' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Источники исполнителей
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogWorkerStatus" :to="{ path: '/worker_statuses'}" :class="$route.path === '/worker_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы исполнителей
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogEmploymentCategory" :to="{ path: '/employment_categories'}" :class="$route.path === '/employment_categories' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Категория занятости
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogDriverLicenseCategory" :to="{ path: '/driver_license_categories'}" :class="$route.path === '/driver_license_categories' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Категории водительских прав
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogJobTitle" :to="{ path: '/job_titles'}" :class="$route.path === '/job_titles' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Должности
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermRole" :to="{ path: '/user_roles'}" :class="$route.path === '/user_roles' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Роли
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogLocationCostType" :to="{ path: '/location_cost_types'}" :class="$route.path === '/location_cost_types' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Типы расходов объекта
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogLocationStatus" :to="{ path: '/location_statuses'}" :class="$route.path === '/location_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы объекта
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogWorkerCostType" :to="{ path: '/worker_cost_types'}" :class="$route.path === '/worker_cost_types' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Типы расходов исполнителя
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogDepartment" :to="{ path: '/departments'}" :class="$route.path === '/departments' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Подразделения
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogWorkService" :to="{ path: '/work_services'}" :class="$route.path === '/work_services' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Услуги самозанятых
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogVacancy" :to="{ path: '/vacancies'}" :class="$route.path === '/vacancies' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Вакансии
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermLocationVacancy" :to="{ path: '/recruit_location_vacancies'}" :class="$route.path === '/recruit_location_vacancies' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Шаблоны вакансий
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogProjectStatus" :to="{ path: '/project_statuses'}" :class="$route.path === '/project_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы проектов
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermRecruitJobPostingStatuses" :to="{ path: '/job_posting_statuses'}" :class="$route.path === '/job_posting_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы объявлений
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermRecruitTaskStatuses" :to="{ path: '/recruit_task_statuses'}" :class="$route.path === '/recruit_task_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы заявок на подбор
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogTaskGroup" :to="{ path: '/task_groups'}" :class="$route.path === '/task_groups' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Группы заявок
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogLeadStatus" :to="{ path: '/lead_statuses'}" :class="$route.path === '/lead_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы лидов
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogCustomerStatus" :to="{ path: '/customer_statuses'}" :class="$route.path === '/customer_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы заказчиков
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogLeadSource" :to="{ path: '/lead_sources'}" :class="$route.path === '/lead_sources' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Источники лидов
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogRecruitTag" :to="{ path: '/recruit_tags'}" :class="$route.path === '/recruit_tags' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Теги заявки на подбор
            </span>
          </b-list-group-item>
          <b-list-group-item v-if="hasPermCatalogRecruitResponseStatus" :to="{ path: '/recruit_response_statuses'}" :class="$route.path === '/recruit_response_statuses' && 'active router-link-active'" :variant="navVariant">
            <v-icon name="navbar/catalog" :size="13" class="mr-1"/>
            <span class="text-small">
              Статусы откликов
            </span>
          </b-list-group-item>
        </b-collapse>
      </b-list-group>

      <!--          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/accruals'}" :class="$route.path === '/accruals' && 'active router-link-active'" :variant="navVariant">-->
      <!--            <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>-->
      <!--            Начисления зарплаты-->
      <!--          </b-list-group-item>-->
      <!--          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/salaries'}" :class="$route.path === '/salaries' && 'active router-link-active'" :variant="navVariant">-->
      <!--            <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>-->
      <!--            Выплаты зарплаты-->
      <!--          </b-list-group-item>-->
      <!--          <b-list-group-item v-if="hasPermStaff" :to="{ path: '/salary_summary'}" :class="$route.path === '/salary_summary' && 'active router-link-active'" :variant="navVariant">-->
      <!--            <font-awesome-icon icon="cash-register" style="color: darkslateblue" class="mr-1"/>-->
      <!--            Зарплатная ведомость-->
      <!--          </b-list-group-item>-->

      <template #footer>
        <div class="sidebar-footer-menu">
          <b-nav-item-dropdown dropup no-caret class="user-profile-dropdown">
            <template #button-content>
              <div class="user-info-content">
                <v-icon name="navbar/user_circle" :size="13" class="mr-1"/>
                <em>{{user.name}}</em>
                <v-icon name="buttons/chevrons_up_down" class="ml-auto" :size="13"/>
              </div>
            </template>
            <b-dropdown-group header="Яркость интерфейса" class="px-3">
              <div class="d-flex align-items-center py-2">
                <b-form-input
                  class="br-range"
                  type="range"
                  min="30"
                  max="100"
                  step="5"
                  :value="brightness"
                  @input="changeBrightness"
                />
              </div>
            </b-dropdown-group>

            <b-dropdown-divider />
            <b-dropdown-item :to="{ path: '/home'}" :class="$route.name === 'Home' && 'active router-link-active'" :variant="navVariant">
              <v-icon name="navbar/home" :size="13" class="mr-1"/>
              Личный кабинет
            </b-dropdown-item>
            <b-dropdown-item @click="logout">
              <v-icon name="buttons/logout" class="mr-1" :size="13"/>
              {{ $t("message.login.logout") }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
      </template>
    </b-sidebar>

    <div v-if="isLoggedIn && isServerAvailable" class="main-layout" :class="{ 'sidebar-closed': !isOpenMenu }">
      <main class="content-frame">
        <router-view/>
      </main>
    </div>

    <div v-else class="auth-layout">
      <router-view/>
    </div>

    <ErrorsModalWindow :offline="noConnectionError" :not-found="notFoundError" :forbidden="forbiddenError" v-model="showErrorModal" @hidden="resetErrorStates"/>

    <portal-target name="app"/>
    <portal v-if="!isOpenMenu && isLoggedIn && isServerAvailable" to="sidebar-toggle">
      <v-icon name="navbar/toggle_menu_right" :size="13" class="sidebar-trigger-internal mr-3" @click="isOpenMenu = true"/>
    </portal>

    <div
      v-if="brightness < 100"
      class="brightness-overlay"
      :style="overlayStyles"
    />
  </div>
</template>

<script>
import ErrorsModalWindow from './components/Alerts/ErrorsModalWindow.vue'
import permissions from "./utilites/permissions";
import {PERM} from "./utilites/permissions";
import { EventBus } from './utilites/eventBus'
import VIcon from "./utilites/commonUi/VIcon.vue";
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {VIcon, ErrorsModalWindow },
  mixins: [permissions],
  data () {
    return {
      user: "",
      navVariant: "",
      isOpenMenu: true,
      isServerAvailable: true,
      noConnectionError: false,
      notFoundError: false,
      forbiddenError: false,
      showErrorModal: false,
      check: null,
    }
  },
  created() {
    window.addEventListener('online', this.checkServerStatus);
    window.addEventListener('offline', this.checkServerStatus);

    EventBus.$on('http-error-404', () => {
      this.forbiddenError = false;
      this.noConnectionError = false;
      this.notFoundError = true;
      this.showErrorModal = true;
    });

    EventBus.$on('http-error-403', () => {
      this.notFoundError = false;
      this.noConnectionError = false;
      this.forbiddenError = true;
      this.showErrorModal = true;
    });
  },
  mounted() {
    if (this.isLoggedIn && this.$route.name !== 'Login') {
      this.userInfo();
    }

    this.checkServerStatus();
    this.check = setInterval(() => {
      this.checkServerStatus();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.check);
    window.removeEventListener('online', this.checkServerStatus);
    window.removeEventListener('offline', this.checkServerStatus);
    EventBus.$off('http-error-404');
    EventBus.$off('http-error-403');
  },
  methods: {
    checkServerStatus() {
      const isOnline = window.navigator.onLine

      if (!isOnline) {
        this.isServerAvailable = false;
        this.noConnectionError = true;
        this.showErrorModal = true;
        return;
      }

      this.$http.get("ping").then(result => {
        if (result.status === 200) {
          this.isServerAvailable = true;
          this.noConnectionError = false;

          if (!this.notFoundError && !this.forbiddenError) {
            this.showErrorModal = false;
          }
        }
      }, error => {
        this.isServerAvailable = false;
        this.noConnectionError = true;
        this.showErrorModal = true;
      });
    },
    resetErrorStates() {
      this.noConnectionError = false;
      this.notFoundError = false;
      this.forbiddenError = false;
      this.showErrorModal = false;
    },
    logout() {
      this.$store.dispatch("logout").then(res => {
        this.user= "";
        this.$router.push('/login').catch(()=>{});
      })
    },
    userInfo() {
      this.$http.get("users/info").then(result => {
        if (result.status === 200) {
          this.user = result.body;
          this.$store.dispatch("updatePermissions", {
            role: result.body.role,
            permissions: result.body.permissions,
          }).then();
        }
      }, error => {
        console.log(error);
      });
    },
    changeBrightness(val) {
      this.$store.dispatch('brightness/updateBrightness', parseInt(val));
    }
  },
  computed: {
    ...mapState('brightness', {
      brightness: state => state.level
    }),
    overlayStyles() {
      const factor = (100 - this.brightness) / 100;
      return {
        backgroundColor: `rgba(0, 0, 0, ${factor * 0.7})`,
      };
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    hasPermCatalog() {
      return this.hasPermission([PERM.CATALOG])
    },
    hasPermCatalogTown() {
      return this.hasPermission([PERM.CATALOG_TOWN])
    },
    hasPermCatalogCitizenship() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS])
    },
    hasPermCatalogWorkType() {
      return this.hasPermission([PERM.CATALOG_WORK_TYPE])
    },
    hasPermCatalogSource() {
      return this.hasPermission([PERM.CATALOG_SOURCE])
    },
    hasPermCatalogWorkerSource() {
      return this.hasPermission([PERM.CATALOG_WORKER_SOURCE])
    },
    hasPermCatalogEmploymentCategory() {
      return this.hasPermission([PERM.CATALOG_EMPLOYMENT_CATEGORY])
    },
    hasPermCatalogDriverLicenseCategory() {
      return this.hasPermission([PERM.CATALOG_DRIVER_LICENSE_CATEGORY])
    },
    hasPermCatalogJobTitle() {
      return this.hasPermission([PERM.CATALOG_JOB_TITLE])
    },
    hasPermCatalogLocationCostType() {
      return this.hasPermission([PERM.CATALOG_LOCATION_COST_TYPE])
    },
    hasPermCatalogLocationStatus() {
      return this.hasPermission([PERM.CATALOG_LOCATION_STATUS])
    },
    hasPermCatalogWorkerCostType() {
      return this.hasPermission([PERM.CATALOG_WORKER_COST_TYPE])
    },
    hasPermCatalogDepartment() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT])
    },
    hasPermCatalogWorkService() {
      return this.hasPermission([PERM.CATALOG_WORK_SERVICE])
    },
    hasPermCatalogVacancy() {
      return this.hasPermission([PERM.CATALOG_VACANCY])
    },
    hasPermCatalogLeadStatus() {
      return this.hasPermission([PERM.CATALOG_LEAD_STATUS])
    },
    hasPermCatalogWorkerStatus() {
      return this.hasPermission([PERM.CATALOG_WORKER_STATUS])
    },
    hasPermCatalogProjectStatus() {
      return this.hasPermission([PERM.CATALOG_PROJECT_STATUS])
    },
    hasPermCatalogTaskGroup() {
      return this.hasPermission([PERM.CATALOG_TASK_GROUP])
    },
    hasPermCatalogCustomerStatus() {
      return this.hasPermission([PERM.CATALOG_CUSTOMER_STATUS])
    },
    hasPermCatalogLeadSource() {
      return this.hasPermission([PERM.CATALOG_LEAD_SOURCE])
    },
    hasPermCatalogRecruitTag() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_TAG])
    },
    hasPermCatalogRecruitResponseStatus() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_RESPONSE_STATUS])
    },
    hasPermRecruitTaskStatuses() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_TASK_STATUS])
    },
    hasPermRecruitJobPostingStatuses() {
      return this.hasPermission([PERM.CATALOG_JOB_POSTING_STATUS])
    },
    hasPermWorker() {
      return this.hasPermission([PERM.WORKER])
    },
    hasPermTask() {
      return this.hasPermission([PERM.TASK])
    },
    hasPermCustomer() {
      return this.hasPermission([PERM.CUSTOMER])
    },
    hasPermLocation() {
      return this.hasPermission([PERM.LOCATION])
    },
    hasPermLocationVacancy() {
      return this.hasPermission([PERM.LOCATION_VACANCY])
    },
    hasPermOrganization() {
      return this.hasPermission([PERM.ORGANIZATION])
    },
    hasPermRecruitTask() {
      return this.hasPermission([PERM.RECRUIT_TASK])
    },
    hasPermRecruitJobPosting() {
      return this.hasPermission([PERM.RECRUIT_JOB_POSTING])
    },
    hasPermUser() {
      return this.hasPermission([PERM.USER])
    },
    hasPermRole() {
      return this.hasPermission([PERM.ROLE])
    },
    hasPermStaff() {
      return this.hasPermission([PERM.STAFF])
    },
    hasPermReport() {
      return this.hasPermission([PERM.REPORT])
    },
    hasPermRegister() {
      return this.hasPermission([PERM.REGISTER])
    },
    hasPermAnalytic() {
      return this.hasPermission([PERM.ANALYTIC])
    },
    hasPermStatistic() {
      return this.hasPermission([PERM.STATISTIC])
    },
  },
  watch: {
    isLoggedIn: {
      handler: function (newVal) {
        if (newVal) {
          this.userInfo();
        } else {
          this.user = "";
        }
        this.isOpenMenu = newVal !== undefined ? newVal : true;
      }
    },
    '$route'() {
      this.showErrorModal = false;
    },
  }
}
</script>

<style>
.sidebar-trigger-internal {
  cursor: pointer;
  color: #6c757d;
  transition: color 0.2s ease;
}

.sidebar-trigger-internal:hover {
  color: #343a40;
}

/* OLD */
.topZIndex{
  z-index: 1050;
}

/* Text */
.text-small {
  font-size: small;
}

.text-menu {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: rgba(10, 15, 23, 0.88);
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

/* FRAME */
.main-layout {
  display: flex;
  padding: 12px 12px 12px 284px;
  min-height: 100vh;
  box-sizing: border-box;
  transition: padding-left 0.3s ease;
}

.main-layout.sidebar-closed {
  padding-left: 12px;
}

.content-frame {
  flex: 1;
  background: #FFFFFF;
  border: 1px solid #E9EDF3;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px rgba(0, 0, 0, 0.02);
  height: calc(100vh - 24px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.auth-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

html, body {
  margin: 0;
  padding: 0;
  background-color: #F5F6F7;
  min-height: 100vh;
}

#app {
  min-height: 100vh;
  background-color: transparent;
}

/* LEFT NAVBAR */

.logo-main {
  max-height: 100%;
  object-fit: contain;
}

.sidebar-brand-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  gap: 10px;
  width: 236px;
  height: 45.45px;
  flex: none;

  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #FFFFFF;
  box-shadow: 0 -12px 0 0 #FFFFFF;
}

#sidebar-1 {
  background-color: #FFFFFF !important;
  border: 1px solid #E9EDF3 !important;
  border-radius: 16px !important;

  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px rgba(0, 0, 0, 0.02) !important;

  margin: 12px;
  height: calc(100vh - 24px) !important;
  top: 0 !important;
  transition: 0.3s ease;
}

#sidebar-1 .b-sidebar-body {
  display: flex;
  flex-direction: column;
  padding: 12px !important;
  gap: 16px;
  overflow-x: hidden !important;
}

#sidebar-1 .b-sidebar-header {
  background: transparent;
  padding: 12px 12px 0 12px;
}

/* Menu */
.menu .list-group-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  /* Отступы */
  padding: 0 32px 0 24px !important;
  /* Расстояние между иконкой и текстом */
  gap: 10px;

  /* Размеры */
  width: 100%;
  min-width: 160px;
  height: 40px;

  /* Оформление */
  background-color: transparent;
  border: none;
  border-radius: 8px;

  color: #0A0F17;
  transition: all 0.2s ease;
  cursor: pointer;
  margin-bottom: 2px;
}

.menu .list-group-item:hover:not(.active) {
  background-color: #ECF7F1;
  color: #1A9167;
}

.menu .list-group-item.active {
  background-color: #ECF7F1 !important;
  color: #1A9167 !important;
  font-weight: 500;
}


.menu .list-group-item .v-icon {
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0A0F17;
  transition: color 0.2s ease;
  flex-shrink: 0;
}

/* Menu footer */

.menu .list-group-item:hover .v-icon,
.menu .list-group-item.active .v-icon {
  color: #1A9167 !important;
}

.sidebar-footer-menu .dropdown,
.sidebar-footer-menu .nav-link,
.sidebar-footer-menu .dropdown-menu {
  list-style-type: none !important;
  padding: 0;
  margin: 0;
  color: inherit !important;
}

.sidebar-footer-menu {
  position: relative;
  display: flex;
  align-items: center;

  padding: 8px 12px !important;
  gap: 12px;
  margin: 0 12px 12px 12px;

  width: 236px;
  height: 58px;

  background: #FFFFFF !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px rgba(0, 0, 0, 0.02) !important;
  border-radius: 8px;
}

.user-profile-dropdown,
.user-profile-dropdown .nav-link,
.user-info-content {
  display: flex !important;
  align-items: center;
  width: 100% !important;
}

.user-info-content em {
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  margin-left: 8px;
}

.user-profile-dropdown .dropdown-menu {
  display: none;

  position: absolute !important;
  bottom: 50px !important;
  left: -12px !important;
  width: 236px !important;
  height: auto !important;

  background: #FFFFFF;
  padding: 4px !important;
  border: none;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.0012), 0 9px 28px 8px rgba(0, 0, 0, 0.05);

  transform: none !important;
  will-change: unset !important;
  top: auto !important;
}

.user-profile-dropdown .dropdown-menu.show {
  display: flex !important;
  flex-direction: column;
}

.user-profile-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  padding: 4px 12px !important;
  height: 32px;
  border-radius: 4px;
  font-size: 13px;
  color: #0A0F17;
  width: 100%;
}

.user-profile-dropdown .dropdown-item:hover {
  background-color: #F5F6F7;
  color: #0A0F17;
}

/* Vertical divider */
.vr {
  border:         none;
  border-left:    1px solid hsla(200, 10%, 50%,100);
  height:         50%;
  width:          1px;
}

/* NEW TABLE */

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: none;
}

.custom-table thead th,
.custom-table tbody td {
  border: none !important;
  box-shadow: inset -1px -1px 0 #E9EDF3;
  padding: 8px !important;
  vertical-align: middle;
}

.custom-table thead th:last-child,
.custom-table tbody td:last-child {
  box-shadow: inset 0 -1px 0 #E9EDF3 !important;
}

.custom-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background-color: #FAFAFA !important;
}

.custom-table .custom-sticky-column {
  position: sticky !important;
  z-index: 2;
  background-clip: padding-box;
  background-color: inherit;
}

.custom-table thead th.custom-sticky-column {
  z-index: 5 !important;
}

.custom-table tbody td.custom-sticky-column {
  background-color: #ffffff;
}

.custom-table .custom-sticky-left-edge {
  position: sticky !important;
  z-index: 2;
}

.custom-table .custom-sticky-left-edge::after {
  content: "";
  position: absolute;
  top: 0; right: -5px; bottom: 0;
  width: 5px;
  pointer-events: none;
  background: linear-gradient(to right, rgba(0,0,0,0.12), rgba(0,0,0,0));
}

.custom-table .custom-sticky-right-edge {
  position: sticky !important;
  z-index: 2;
  box-shadow: inset 1px 0 0 #E9EDF3, inset -1px -1px 0 #E9EDF3 !important;
}

.custom-table .custom-sticky-right-edge::after {
  content: "";
  position: absolute;
  top: 0; left: -5px; bottom: 0;
  width: 5px;
  pointer-events: none;
  background: linear-gradient(to left, rgba(0,0,0,0.12), rgba(0,0,0,0));
}

.custom-table thead th.custom-sticky-left-edge::before,
.custom-table thead th.custom-sticky-right-edge::before {
  content: "";
  position: absolute;
  top: 0; bottom: 0;
  width: 5px;
  background-color: #FAFAFA;
  z-index: -1;
}
.custom-table thead th.custom-sticky-left-edge::before {
  right: -5px;
}
.custom-table thead th.custom-sticky-right-edge::before {
  left: -5px;
}

.custom-table thead th.custom-sticky-left-edge,
.custom-table thead th.custom-sticky-right-edge {
  z-index: 5 !important;
  background-color: #FAFAFA !important;
  overflow: visible;
}

.custom-table tbody td.custom-sticky-left-edge,
.custom-table tbody td.custom-sticky-right-edge {
  background-color: #FFFFFF;
}

.page-table-container .custom-table tbody tr.b-table-row-selected td {
  background-color: #ECF7F1 !important;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1), inset -1px -1px 0 #E9EDF3 !important;
  color: inherit;
}

.page-table-container .custom-table tbody tr.b-table-row-selected td.custom-sticky-left-edge,
.page-table-container .custom-table tbody tr.b-table-row-selected td.custom-sticky-right-edge {
  background-color: #ECF7F1 !important;
}

.page-table-container .custom-table tbody tr.b-table-row-selected td.custom-sticky-right-edge {
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1), inset 1px 0 0 #E9EDF3, inset 0 -1px 0 #E9EDF3 !important;
}

.custom-table tbody tr:hover td {
  background-color: #ECF7F1 !important;
}
.custom-table tbody tr:hover td.custom-sticky-left-edge,
.custom-table tbody tr:hover td.custom-sticky-right-edge {
  background-color: #ECF7F1 !important;
}

.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
  border-top: 0;
}

.custom-table td.custom-sticky-column:has(.custom-dropdown.show) {
  z-index: 10 !important;
}
/* Content Sticky Header */
#header {
  top: 56px;
  position: sticky;
  z-index: 1020;
}

/* Content Sticky Footer */
#footer {
  position: sticky;
  bottom: 0;
}

/* Content Sticky Filters */
#filters {
  position: sticky;
  top: 87px;
  z-index: 5;
  background-color: white;
}

/* Model Content Padding */
.modal-body-select {
  padding: 0 !important
}

/* Model Content Sticky */
.modal-sticky {
  max-height: calc(100vh - 300.8px) !important;
}

/* Model Content Sticky Filters */
#modal-filters {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: white;
}

/* Autocomplete Select Input */
.autocomplete-input {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 2000;
}

/* Autocomplete Select Input Group Item */
.autocomplete-input .list-group-item {
  padding: 0.5rem 1rem;
}

/* REDESIGN TABLES */

.page-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  gap: 8px;
  height: 56px;
  flex: 0 0 56px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  background: #fff;
}

.page-body {
  display: flex;
  flex-direction: column;
  padding: 12px 20px 20px;
  gap: 16px;
  flex: 1 1 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.page-filters {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  flex: 0 0 32px;
  gap: 8px;
}

.page-table-container {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 1 auto;
  border: 1px solid #E9EDF3;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.page-pagination {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 24px;
  flex: 0 0 auto;
}

.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
}

.page-table-container .b-table-sticky-header {
  height: 100% !important;
  max-height: 100% !important;
  margin-bottom: 0;
}

.page-table-container table {
  margin-bottom: 0;
}

.page-table-container th {
  border-top: none !important;
}

/* BUTTONS */

.custom-btn-primary,
.custom-common-modal .modal-footer .btn-primary {
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  padding: 0 8px !important;
  gap: 8px;
  min-width: 32px;
  height: 32px !important;
  background: #1A9167 !important;
  color: #FFFFFF !important;
  border: 1px solid #1A9167 !important;
  box-shadow: 0 2px 0 #ECFFFD !important;
  border-radius: 6px !important;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-btn-primary:hover,
.custom-common-modal .modal-footer .btn-primary:hover {
  background: #1eab79 !important;
  border-color: #1eab79 !important;
  color: #FFFFFF !important;
}

.custom-btn-primary:active,
.custom-common-modal .modal-footer .btn-primary:active {
  background: #147351 !important;
  border-color: #147351 !important;
  box-shadow: none !important;
  transform: translateY(1px);
}

.custom-btn-primary:disabled {
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  box-shadow: none !important;
}

.custom-btn-secondary,
.custom-common-modal .modal-footer .btn-secondary {
  display: inline-flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 7px !important;
  gap: 8px;
  min-width: 32px;
  height: 32px !important;
  background: #FFFFFF !important;
  color: rgba(0, 0, 0, 0.85) !important;
  border: 1px solid #DCE2EA !important;
  box-shadow: 0 2px 0 rgba(10, 15, 23, 0.02) !important;
  border-radius: 6px !important;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-btn-secondary:hover,
.custom-common-modal .modal-footer .btn-secondary:hover {
  border-color: #1A9167 !important;
  color: #1A9167 !important;
}

.custom-btn-secondary:active,
.custom-common-modal .modal-footer .btn-secondary:active {
  border-color: #147351 !important;
  color: #147351 !important;
  box-shadow: none !important;
  transform: translateY(1px);
}

.custom-btn-danger,
.custom-common-modal .modal-footer .btn-danger {
  display: inline-flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 7px !important;
  min-width: 32px;
  height: 32px !important;

  background: #FFF1F0 !important;
  color: #dc3545 !important;
  border: 1px solid #FFA39E !important;

  box-shadow: 0 2px 0 rgba(10, 15, 23, 0.02) !important;
  border-radius: 6px !important;
  font-size: 14px;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-btn-danger:hover:not(:disabled),
.custom-common-modal .modal-footer .btn-danger:hover {
  background: #FFCCC7 !important;
  border-color: #FFA39E !important;
  cursor: pointer;
}

.custom-btn-danger:active,
.custom-common-modal .modal-footer .btn-danger:active {
  border-color: #dc3545 !important;
  color: #dc3545 !important;
  box-shadow: none !important;
  transform: translateY(1px);
}

.custom-btn-danger:disabled,
.custom-common-modal .modal-footer .btn-danger:disabled {
  background: #F5F5F5 !important;
  color: #B8B8B8 !important;
  border-color: #D9D9D9 !important;
  cursor: not-allowed;
}

.custom-btn-select {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 4px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  cursor: pointer;
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-btn-select:hover {
  color: #1A9167;
}

.custom-btn-select:focus {
  outline: none;
}

.custom-btn-select:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.custom-btn-tag {
  --btn-color: #1A9167;
  --btn-border: #147351;
  --btn-text: #FFFFFF;

  background-color: var(--btn-color) !important;
  border: 1px solid var(--btn-border) !important;
  color: var(--btn-text) !important;

  display: inline-flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 8px !important;
  height: 24px !important;

  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.05) !important;
  border-radius: 6px !important;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-btn-tag:hover {
  filter: brightness(1.07) !important;
  color: var(--btn-text) !important;
}

.custom-btn-tag:active {
  filter: brightness(0.9) !important;
  transform: translateY(1px);
}

.custom-btn-tag i,
.custom-btn-tag svg {
  fill: var(--btn-text);
  color: var(--btn-text);
}

.custom-btn-tag:disabled {
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  filter: none !important;
  cursor: not-allowed !important;
}

.custom-btn-dashed {
   box-sizing: border-box;
   display: flex !important;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   padding: 0 7px;
   gap: 8px;
   width: 100%;
   min-width: 24px;
   height: 24px;
   background: #FFFFFF;
   border: 1px dashed #DCE2EA !important;
   box-shadow: 0 2px 0 rgba(10, 15, 23, 0.02) !important;
   border-radius: 4px;
   color: #6c757d !important;
   font-size: 12px;
   cursor: pointer;
   transition: background 0.15s ease-in-out;
 }

.custom-btn-dashed:hover {
  background: #f8f9fa;
}

.custom-btn-dashed:focus {
  outline: none;
  background: #FFFFFF !important;
  border-color: #6c757d !important;
}


.custom-tooltip.tooltip {
  opacity: 1 !important;
  transition: none !important;
}

.custom-tooltip .tooltip-inner {
  background-color: #1A9167 !important;
  border-radius: 6px !important;
  font-size: 14px;
  padding: 4px 8px;
}

.custom-tooltip.bs-tooltip-top .arrow::before { border-top-color: #1A9167 !important; }
.custom-tooltip.bs-tooltip-bottom .arrow::before { border-bottom-color: #1A9167 !important; }
.custom-tooltip.bs-tooltip-left .arrow::before { border-left-color: #1A9167 !important; }
.custom-tooltip.bs-tooltip-right .arrow::before { border-right-color: #1A9167 !important; }

.btn:focus,
.btn.focus,
.btn:active:focus {
  outline: 0 !important;
  box-shadow: none !important;
}

.cursor-pointer {
  cursor: pointer;
}

.search-btn {
  align-self: stretch;
  width: 44px;
  background: #FFFFFF;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  border-color: #DCE2EA;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
}

.search-btn:hover {
  background: #f8f9fa;
  color: #333;
}
/* MODAL */

.custom-modal {
  .modal-content {
    border: none;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
    filter: drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.08));
    overflow: hidden;
  }

  .modal-header, .modal-footer {
    border-top: 1px solid #E9EDF3 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
    padding: 12px 24px;
    align-items: center;
    background-color: #FFFFFF;
  }

  .modal-body {
    padding: 24px;
  }

  .form-group label {
    font-size: 13px;
    margin-bottom: 4px;
    color: #64748b;
  }

  .form-control {
    height: 32px;
    padding: 4px 12px;
    background: #FFFFFF;
    border-radius: 6px;
    font-size: 14px;
    color: #1a1d23;
    transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    box-shadow: none;
  }

  .form-control:focus {
    border-color: #f5f5f5;
    box-shadow: 0 0 0 2px rgba(10, 163, 102, 0.3);
    outline: 0;
  }

  .form-control::placeholder {
    color: #bfbfbf;
  }

  .form-control:disabled {
    background-color: #e9ecef;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    border-color: #d9d9d9;
  }

  /*
  .form-group {
    margin-bottom: 16px;
  }
   */

  .form-group label {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 4px;
  }
}

.modal-body-select .page-body {
  height: 100% !important;
}

.custom-collapse-group {
  display: flex;
  flex-direction: column;
  background: rgba(10, 15, 23, 0.04);
  border-radius: 8px;
  width: 100%;
  margin-bottom: 16px;
  overflow: visible;
  position: relative;
}

.custom-collapse-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
  height: 46px;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s ease;
  border-radius: 8px 8px 0 0;
}

.custom-collapse-header.collapsed {
  border-radius: 8px;
}

.custom-collapse-header:hover {
  background: rgba(10, 15, 23, 0.04);
}

.custom-collapse-header-title {
  font-weight: 600;
  font-size: 14px;
  color: #1a1d23;
}

.custom-collapse-body {
  padding: 0 16px 16px 16px;
  background: transparent;
  border-radius: 0 0 8px 8px;
}

.chevron-icon {
  transition: transform 0.2s ease;
}

.collapsed .chevron-icon {
  transform: rotate(-90deg);
}

/* TAB */
.tabs.custom-tabs .nav-tabs {
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 0;
  display: flex;
}

.tabs.custom-tabs .nav-item {
  margin-right: 4px;
}

.tabs.custom-tabs .nav-item:last-child {
  margin-right: 0;
}

.tabs.custom-tabs .nav-link {
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;

  width: auto;
  height: auto;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;

  color: #000000;
  background-color: transparent !important;
  border: none !important;
  border-bottom: 2px solid transparent !important;
  border-radius: 0 !important;

  transition: color 0.3s, border-color 0.3s;
  white-space: nowrap;
}

.tabs.custom-tabs .nav-link:hover {
  color: #1A9167;
  border-bottom: 2px solid #f0f0f0 !important;
}

.tabs.custom-tabs .nav-link.active {
  color: #1A9167 !important;
  font-weight: 500;
  border-bottom: 2px solid #1A9167 !important;
  background-color: transparent !important;
}

.tabs.custom-tabs .card-header-tabs {
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 0 !important;
}

.tabs.custom-tabs .card-header {
  background-color: transparent !important;
  border-bottom: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* checkbox */

.custom-checkbox .custom-control-label::before {
  border: 1px solid #adb5bd !important;
  box-shadow: none !important; /* Убирает синий дефолт при любых раскладах */
  transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s !important;
}

.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,
.custom-checkbox .custom-control-input:active ~ .custom-control-label::before {
  border-color: #1A9167 !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #1A9167 !important;
}

.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(26, 145, 103, 0.25) !important;
}

.custom-checkbox .custom-control-input:active ~ .custom-control-label::before {
  background-color: rgba(26, 145, 103, 0.3) !important;
}

.custom-checkbox .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.5;
}

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #1A9167 !important;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #FFFFFF !important;
  border-color: #DCE2EA !important;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: none !important;
  background-color: #1A9167;

  width: 8px !important;
  height: 8px !important;

  left: -20px !important;
  top: 8px !important;

  border-radius: 1px;
}

/* tag */

.custom-tag {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1px 7px;
  gap: 3px;
  height: 22px;
  border-radius: 4px;

  color: rgba(10, 15, 23, 0.88);
  font-family: 'IBM Plex Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.tag-success {
  background: #F6FFED;
  border: 1px solid #B7EB8F;
  color: #389E0D !important;
}

.tag-warning {
  background: #FFF7E6;
  border: 1px solid #FFE58F;
  color: #FAAD14 !important;
}

.tag-danger {
  background: #FFF1F0;
  border: 1px solid #FFA39E;
  color: #dc3545;
}

.tag-info {
  background: #F0F5FF;
  border: 1px solid #D9E0FF;
  color: #061178;
}

.tag-secondary {
  background: rgba(10, 15, 23, 0.15);
  border: 1px solid rgba(10, 15, 23, 0.3);
  color: rgba(10, 15, 23, 0.88);
}

.tag-primary {
  background: #85A5FF;
  border: 1px solid #6C8EEA;
  color: #1740B4 !important;
}

.tag-purple {
  background: #F9F0FF;
  border: 1px solid #D6BEEA;
  color: #22075E;
}


/* b-card */

.custom-card {
  border: none !important;
  box-sizing: border-box;
  background: rgba(10, 15, 23, 0.04) !important;
  border-radius: 8px !important;
  position: relative;
  width: 100%;
  overflow: visible !important;
}

.custom-card .card-body {
  display: flex;
  flex-direction: column;
  padding: 20px !important;
  gap: 16px;
}

.custom-card .card-body > .form-group,
.custom-card .card-body > div,
.custom-card .card-body > .custom-control {
  width: 100%;
  margin-bottom: 0;
}


/* NEW form-control */

.custom-card .form-control:not(textarea),
.custom-table .form-control:not(textarea),
.custom-sidebar-container .form-control:not(textarea),
.filters-flyout .form-control:not(textarea),
.custom-card .custom-select,
.custom-collapse-group .custom-select,
.custom-sidebar-container .custom-select,
.filters-flyout .custom-select{
  height: 32px;
  padding: 4px 12px;
  background: #FFFFFF;
  border-radius: 6px;
  font-size: 14px;
  color: #1a1d23;
  border: 1px solid #DCE2EA;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-card textarea.form-control {
  min-height: 80px !important;
  resize: vertical !important;
  transition: none !important;
  display: block !important;

  padding: 8px 12px;
  background: #FFFFFF;
  border-radius: 6px;
  color: #1a1d23;
  border: 1px solid #DCE2EA;
}

.custom-card .form-control:focus,
.custom-table .form-control:focus,
.custom-card .custom-select:focus,
.custom-sidebar-container .form-control:focus,
.custom-sidebar-container .custom-select:focus,
.filters-flyout .form-control:focus,
.filters-flyout .custom-select:focus {
  box-shadow: 0 0 0 0.2rem rgba(26, 145, 103, 0.2) !important;
}

.input-group > input.form-control {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.input-group-append .btn {
  height: 32px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  margin-left: -1px;
  padding: 0 12px;
  display: flex;
  align-items: center;
}

.input-group > .input-group-append > .custom-btn-secondary {
  margin-left: -1px;
}

.input-group > .input-group-append > .custom-btn-primary {
  margin-left: -1px;
}

.form-control.is-invalid,
.custom-select.is-invalid {
  z-index: 5;
  border-color: #ff8782 !important;
  background-image: none !important;
  padding-right: 12px !important;
}

.form-control.is-invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2) !important;
}

.form-control.is-valid,
.custom-select.is-valid {
  z-index: 5;
  border-color: #1A9167 !important;
  background-image: none !important;
  padding-right: 12px !important;
}

.form-control.is-valid:focus,
.custom-select.is-valid:focus {
  border-color: #1A9167 !important;
  box-shadow: 0 0 0 0.2rem rgba(26, 145, 103, 0.2) !important;
}

.invalid-feedback {
  font-size: 12px;
  color: #dc3545;
  margin-top: 4px;
}

/* scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: #adb5bd transparent;
}

/* table`s select */

.page-body.overflow-visible {
  overflow: visible !important;
}

.page-table-container.overflow-visible {
  overflow: visible !important;
}

.custom-table td {
  overflow: visible !important;
  position: relative;
}

/* SIDEBAR */

.custom-sidebar-container .b-sidebar-header {
  border-bottom: 1px solid #E8E8E8 !important;
}

.custom-sidebar-container {
  width: 394px !important;
  top: 16px !important;
  right: 16px !important;
  height: calc(100vh - 32px) !important;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.0012), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
  filter: drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.08));
  border-radius: 16px !important;
  border: none !important;
}

.export-list-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 0 8px;
  margin-bottom: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.export-list-item:hover {
  background-color: #e9ecef;
}

.ant-switch-wrapper {
  position: relative;
  width: 45px;
  height: 22px;
  display: inline-flex;
  cursor: pointer;
}

.ant-switch-wrapper .custom-control {
  padding-left: 0;
  min-height: 22px;
  margin: 0;
  z-index: 2;
}

.ant-switch-wrapper .custom-control-label::before {
  left: 0;
  top: 0;
  width: 45px;
  height: 22px;
  border-radius: 11px;
  border: none;
  background-color: #00000040;
  box-shadow: none !important;
  transition: background-color 0.2s ease;
}

.ant-switch-wrapper .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #1A9167 !important;
}

.ant-switch-wrapper .custom-control-label::after {
  left: 2px;
  top: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #ffffff;
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0,35,11,0.2);
  transition: transform 0.2s cubic-bezier(0.2, 0.85, 0.32, 1.2);
  z-index: 4;
}

.ant-switch-wrapper .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(23px);
}

.pure-switch-track {
  position: absolute;
  left: 0;
  top: 0;
  width: 45px;
  height: 22px;
  border-radius: 11px;
  background-color: #00000040;
  transition: background-color 0.2s ease;
  z-index: 1;
}

.pure-switch-track.is-checked {
  background-color: #1A9167;
}

/* Ползунок */
.pure-switch-thumb {
  position: absolute;
  left: 2px;
  top: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0,35,11,0.2);
  transition: transform 0.2s cubic-bezier(0.2, 0.85, 0.32, 1.2);
  z-index: 3;
}

.pure-switch-thumb.is-checked {
  transform: translateX(23px);
}

.switch-icons-overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  align-items: center;
  z-index: 2;
  pointer-events: none;
}

/* PAGINATION */

.custom-pagination-container ul.pagination {
  margin-bottom: 0 !important;
}

.custom-pagination-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 24px;
  gap: 10px;
  box-sizing: border-box;
  font-size: 13px;
}

.pagination-left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
  gap: 8px;
}

.pagination-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.pagination-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1 0;
  min-width: 0;
  gap: 10px;
}

.custom-pagination-container .page-item .page-link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  transition: all 0.2s ease;
}

.custom-pagination-container .page-item:not(.active):not(.disabled) .page-link:hover {
  background-color: rgba(0, 0, 0, 0.04);
  color: #1A9167;
}

.custom-pagination-container .page-item.active .page-link {
  background-color: #FFFFFF;
  border-color: #1A9167;
  color: #1A9167;
  font-weight: 500;
  z-index: 1;
}

.custom-pagination-container .page-item .page-link:focus {
  outline: none !important;
  box-shadow: 0 0 0 0.2rem rgba(26, 145, 103, 0.25) !important;
}

.custom-per-page-select {
  align-items: center;
  padding: 0 24px 0 8px !important;
  font-size: 12px;
  border: 1px solid #E9EDF3;
  border-radius: 4px;
  width: auto;
  background-color: transparent;
}

.vertical-divider {
  width: 1px;
  height: 14px;
  background-color: #E9EDF3;
}

/* radio */

.custom-radio .custom-control-label::before { border: #adb5bd solid 1px !important; box-shadow: none !important; transition: all .15s !important; }

.custom-radio .custom-control-input:focus ~ .custom-control-label::before,
.custom-radio .custom-control-input:checked ~ .custom-control-label::before { border-color: #1A9167 !important; }

.custom-radio .custom-control-input:checked ~ .custom-control-label::before { background-color: #1A9167 !important; }
.custom-radio .custom-control-input:focus ~ .custom-control-label::before { box-shadow: 0 0 0 .2rem rgba(26, 145, 103, .25) !important; }

.custom-radio .custom-control-input:active ~ .custom-control-label::before { background-color: rgba(26, 145, 103, .3) !important; }
.custom-radio .custom-control-input:disabled ~ .custom-control-label { opacity: .5; }

/* DROPDOWN */

.custom-dropdown .dropdown-menu {
  background: #FFFFFF !important;
  padding: 4px !important;
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08), 0 3px 6px -4px rgba(0,0,0,0.01), 0 9px 28px 8px rgba(0,0,0,0.05) !important;
  min-width: 160px;
}

.custom-dropdown .dropdown-item {
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  padding: 4px 12px !important;
  border-radius: 4px !important;
  font-size: 13px !important;
  color: #0A0F17 !important;
  transition: background 0.2s;
}

.custom-dropdown .dropdown-item:hover {
  background-color: #ECF7F1;
}

.custom-dropdown .dropdown-item .v-icon {
  color: #6c757d;
}

.custom-dropdown .dropdown-item:hover .v-icon {
  color: #1A9167;
}

.custom-dropdown .dropdown-item.btn-delete:hover {
  color: #dc3545 !important;
}
.custom-dropdown .dropdown-item.btn-delete:hover .v-icon {
  color: #dc3545 !important;
}

/* KANBAN */

.kb-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 10px;

  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E9EDF3;
  border-radius: 12px;

  transition: box-shadow 0.2s, transform 0.2s;
  cursor: grab;
}

.kb-card.border-default {
  border: 1px solid #E9EDF3;
}

.kb-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-3px);
  z-index: 2;
}

.ghost-card .kb-card {
  transform: translateY(0) !important;
  box-shadow: none !important;
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-group {
  margin-bottom: 0;
}

/* modal delete */

.custom-common-modal .modal-dialog {
  width: 385px;
  max-width: 385px;
}

.custom-common-modal .modal-content {
  min-height: 160px;
  background: #FFFFFF;
  border: none;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.0012), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
}

.custom-common-modal .modal-body,
.custom-common-modal .modal-footer {
  padding: 0;
  border: none;
  background: transparent;
}

.custom-common-modal .custom-delete-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
}

.custom-common-modal .custom-delete-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-common-modal .custom-delete-title {
  font-weight: 600;
  font-size: 16px;
  color: #212529;
}

.custom-common-modal .custom-delete-message {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.5;
}

.custom-common-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: auto;
}

.custom-common-modal .modal-footer > * {
  margin: 0 !important;
}

/* new select */

.custom-dropdown-select {
  max-height: 300px;
  margin-top: 3px;
  min-width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 1060;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  padding: 0;
}

.custom-dropdown-select-item {
  padding: 10px 15px;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  transition: background 0.15s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.custom-dropdown-select-item:hover,
.custom-dropdown-select-item:focus {
  background-color: #ECF7F1;
  outline: none;
}

.select-input-body-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 4;
  pointer-events: none;
}

.select-input-body-wrapper .custom-btn-select {
  position: static !important;
  transform: none !important;
  right: auto !important;
  top: auto !important;
  pointer-events: auto;
  display: flex;
  flex-shrink: 0 !important;

  padding: 4px 2px 3px 6px !important;
  overflow: visible !important;
  line-height: 0;
}

.custom-dropdown-select-footer {
  background-color: #f8f9fa;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.custom-dropdown-list-scroll {
  overflow-y: auto;
  flex-grow: 1;
}

/* calendar */

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
}

.calendar-grid.header {
  margin-bottom: 8px;
}

.weekday-cell {
  text-align: left;
  font-size: 13px;
  color: #6c757d;
  padding-left: 4px;
}

.date-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px;
  min-height: 78px;
  background: #FFFFFF;
  border: 1px solid #f0f2f5;
  border-radius: 4px;
  overflow: hidden;
}

.date-cell:hover {
  background: #ECF7F1;
}

.date-cell.is-selected {
  background: #ECF7F1;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  color: inherit;
}

.is-not-current-month {
  opacity: 0.4;
}

.day-number {
  font-weight: 500;
  font-size: 14px;
  color: #212529;
}

.month-label {
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
}

/* calendar tags */
.tasks-tags-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.calendar-task-tag {
  max-width: 100%;
  display: block;
  font-size: 11px;
  padding: 2px 6px;
  background-color: #1A9167;
  color: #FFFFFF;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s;
}

.calendar-task-tag:hover {
  background-color: #1eab79;
}

.calendar-task-tag.more-tag {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px dashed #ced4da;
  font-weight: 500;
}

.calendar-task-tag.more-tag:hover {
  background-color: #e9ecef;
}

.text-muted:hover {
  color: #1A9167 !important;
}

/* brightness */
.brightness-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  pointer-events: none;
  transition: background-color 0.1s ease;
  will-change: backdrop-filter, background-color;
}

.br-range:focus {
  box-shadow: none !important;
  outline: none !important;
}
.br-range::-webkit-slider-thumb {
  background: #1A9167 !important;
  border: none !important;
  transition: background .15s ease-in-out, box-shadow .15s ease-in-out !important;
}
.br-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(26, 145, 103, 0.25) !important;
}
.br-range::-webkit-slider-thumb:hover { background: #1eab79 !important; }
.br-range::-webkit-slider-thumb:active { background: #147351 !important; }

.br-range::-moz-range-thumb {
  background: #1A9167 !important;
  border: none !important;
}
.br-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(26, 145, 103, 0.25) !important;
}

/* popover */

.custom-popover.popover {
  padding: 0 !important;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  overflow: visible;
}

.custom-popover .popover-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 10px 15px;
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.custom-popover .popover-body {
  padding: 12px 15px;
  color: #333;
}

.custom-popover.bs-popover-right > .arrow::before {
  border-right-color: #dee2e6 !important;
}

.custom-popover.bs-popover-right > .arrow::after {
  left: 1px;
  border-right-color: #f8f9fa !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue